import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './TeamPage.css';

const teamData = {
  'a-team': {
    name: 'A-team',
    logo: '/img/Team logo/A-team-uten-tekst.png',
    description: 'A-team is responsible for software architecture and design of the application, crafting patterns to support development of new and existing features by the domain teams. Together with Bond team, A-team successfully introduced in-memory Redis database, event system, REST APIs, webhook system, RDS read replica to address massive increase of customer base.'
  },
  'agro': {
    name: 'Agro',
    logo: '/img/Team logo/Agro-uten-tekst.png',
    description: 'We develop and maintain Agro Økonomi onprem and the connected cloud services in www.agro24.no, and the operations related to the product. Including the integrations with Tripletex.'
  },
  'angry-nerds': {
    name: 'Angry nerds',
    logo: '/img/Team logo/Angry-nerds-uten-tekst.png',
    description: 'We’re the team behind the Tripletex mobile app — trusted by almost 150,000 people every month and loved by our users ️ From expenses and invoicing to time tracking, our app helps businesses work smarter — and we’re constantly raising the bar. As a focused, autonomous team of developers, product people and a designer, we own the entire mobile experience: from feature development and user journeys to infrastructure and releases. Our mission is simple — to deliver a world-class app that’s seamless, powerful, and enjoyable to use. Innovation drives everything we do. We regularly experiment with new ideas and explore how emerging technologies, including AI, can make the app even better. Built on React Native and Expo, we continuously improve and evolve to meet our users’ needs. Above all, we’re passionate about crafting mobile products people love — and we’re just getting started.'
  },
 
  'astro': {
    name: 'Astro',
    logo: '/img/Team logo/Astro-uten-tekst.png',
    description: 'Astro has ownership of our frontend frameworks, our design system Atlas and initiatives like Storybook and Snowplow. We create components for our design system and help our domain teams implement them via mob sessions and general React support.'
  },
  'beehive': {
    name: 'Beehive',
    logo: '/img/Team logo/Beehive-uten-tekst.png',
    description: 'Beehive is a team that, just like bees, are all over the place. Our domain is quite broad and we work with everything from onboarding and subscription management to the Tripletex dashboard and reporting module. Lets get buzzzzin!'
  },
  'bond': {
    name: 'Bond',
    logo: '/img/Team logo/Bond-uten-tekst.png',
    description: 'The Black Ops Ninja Department stays in the shadows and if we have done a good job then no one has noticed. We both operate and develop the infrastructure for Tripletex. All of the production-critical services; servers, databases, network traffic and security. We are also responsible for ensuring that developers, in a safe and efficient manner, can use all our resources for testing and deploying new code.'
  },
  'eagle': {
    name: 'Eagle',
    logo: '/img/Team logo/Eagle-uten-tekst.png',
    description: 'eAgle is the team that works with the overall eAccounting product. eAccounting is an accounting software that helps small businesses run their business in a smart way. The eAgles C#!'
  },
  'goldshark': {
    name: 'Goldshark',
    logo: '/img/Team logo/Goldshark-uten-tekst.png',
    description: '«To stock or not to stock?», is the question (we are concerned about)! Clear modules for customers who only need some products in the system and customers looking to control their purchases, orders, stock and value better. API/Backend support for all product and logistics functions and a deliciously updated react frontend. This makes life easier for customer, partners and us alike.'
  },
  'killbill': {
    name: 'KillBill',
    logo: '/img/Team logo/KillBill-uten-tekst.png',
    description: 'As you might have guessed, we are responsible for handling the bills the customers want to get paid for - the outgoing invoices. Our domain gives customers possibility to send and handle offers -> orders -> invoices -> credit note -> reminders -> debt collection/factoring. Invoicing is core of the business to get paid and thus majority of the Tripletex customers are using our pages. We are also handling the Customer/Vendor area to keep overview of who you are buying from and selling to. «You And I Have Unfinished Business!» - The Bride'
  },
  'krr': {
    name: 'KRR',
    logo: '/img/Team logo/KRR-uten-tekst.png',
    description: 'KRR is the ultimate core team in Tripletex, with a domain that contains the core accounting functions, as well as VAT, SAF-T and reports.  We also maintain the report module.'
  },
  'optimus': {
    name: 'Optimus',
    logo: '/img/Team logo/Optimus-uten-tekst.png',
    description: 'Where the magic happens. Team Optimus is responsible for our groundbreaking AI-Assistant, and has an overall focus on giving added value to the Tripletex product through the use of AI.'
  },
  'phoenix': {
    name: 'Phoenix',
    logo: '/img/Team logo/Phoenix-uten-tekst.png',
    description: 'The Phoenix team is responsible for the year-end solution in Tripletex. The year-end solution is brand new, and thus were working with the cutting edge technology, and we are pushing forward the expectations one should have to such a solution.'
  },
  'piggy-bank-crew': {
    name: 'Piggy Bank Crew',
    logo: '/img/Team logo/PBC-uten-tekst.png',
    description: 'PBCs mission is to move the bank within Tripletex. This is done by providing super smooth banking functionality towards our customers. The team is responsible for maintaining and developing the banking integrations.'
  },
  'pt': { 
    name: 'PT',
    logo: '/img/Team logo/PT-uten-tekst.png',
    description: 'PT are responsible for running projects on our internal systems. We work mostly with our colleagues in Sales, Support and Marketing to ensure that they have the best possible tools for them to reach their goals. This includes our support systems (chat, email, tickets, etc.) and sales tools. PT are also responsible for internal IT, ensuring that our people have the right hardware and get help if and when they need it. «Progress not perfection»'
  }, 
  'relions': {
    name: 'Relions',
    logo: '/img/Team logo/relions.png',
    description: 'Relions has the overall responsibility for the Accounting Office segment at product and development in Tripletex. Our vision is to create new and unexplored opportunities for accountants. «You can count on the account ants!»'
  },
  'sheet-storm': {
    name: 'Sheet Storm',
    logo: '/img/Team logo/SheetStorm-uten-tekst.png',
    description: 'Our main responsibility is the Project module, where we ensure a seamless and intuitive experience for our users. Key features within the module include the Wholesaler and Boligmappa integrations, Control forms, and the Resource Planner. Our goal is to make the user flows between the Project module and the other modules smooth and effortless. We maintain core functionality while continuously developing new features that improve usability and add real value. Collaboration, creativity, and user-focused design guide everything we do'
  },
  
  'tsk': {
    name: 'TSK',
    logo: '/img/Team logo/TSK-uten-tekst.png',
    description: 'Introducing the elite force of Tripletex! Tripletex Spesialkommando (TSK) is one of the original three teams. As a well-trained unit, we handle Salary, Travels and Expenses, and most things having to do with Employees. Our mission is to deliver unparalleled solutions and conquering any challenges standing in our way. Join us as we lead the charge into the digital frontier.'
  },
  'task-fox': {
    name: 'Task Fox',
    logo: '/img/Team logo/taskfoxlogo-uten-tekst.png',
    description: 'Making supplier invoices more efficient'
  },
  'time-travellers': {
    name: 'Time Travellers',
    logo: '/img/Team logo/time-travellers2.png',
    description: 'We strive to make time management and expense tracking more efficient and user friendly.'
  }
};

function TeamPage() {
  const { teamName } = useParams();
  const team = teamData[teamName];

  if (!team) {
    return <div>Team not found</div>;
  }

  return (
    <div id="our-teams" className="fh5co-features-outer">
      <div className="container teams-container">
        <div className="row justify-content-center description">
          <div className="col-sm-4 fadeIn team-image-container animated" data-wow-delay="0.25s">
            <img className="float-left team-image" src={team.logo} alt={team.name} />
          </div>
          <div className="col-sm-6 team wow fadeIn animated" data-wow-delay="0.67s">
            <h2>{team.name}</h2>
            <p className="">{team.description}</p>
          </div>
        </div>
        <Link to="/#our-teams">Back to team overview</Link>
      </div>
    </div>
  );
}

export default TeamPage;
